module.exports = __webpack_public_path__ + "img/undraw-building_websites.fe99b6de.png";